import Swiper from "swiper";
import "swiper/swiper-bundle.css";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// ..
AOS.init({
    once: true,
});

const testimonials = new Swiper(".testimonials-slider", {
    navigation: {
        nextEl: ".testimonials-swiper-button-next",
        prevEl: ".testimonials-swiper-button-prev",
    },
    loop: true,
});

if (jQuery(".testimonials-slider").length > 0) {
    jQuery(".testimonials-swiper-button-prev").on("click", function () {
        testimonials.slidePrev();
    });

    jQuery(".testimonials-swiper-button-next").on("click", function () {
        testimonials.slideNext();
    });
}

const fixedBar = document.getElementById("single-fixed-bar");

if (fixedBar != undefined) {
    window.addEventListener("scroll", () => {
        const heroHeight = document.getElementById("single-hero").offsetHeight;

        if (window.scrollY > heroHeight) {
            fixedBar.classList.add("bar-visible");
        } else {
            fixedBar.classList.remove("bar-visible");
        }
    });
}
